/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum MemberRole {
  MEMBER_ROLE_BLOCKED = "MEMBER_ROLE_BLOCKED",
  MEMBER_ROLE_CREATOR = "MEMBER_ROLE_CREATOR",
  MEMBER_ROLE_MEMBER = "MEMBER_ROLE_MEMBER",
  MEMBER_ROLE_MODERATOR = "MEMBER_ROLE_MODERATOR",
  MEMBER_ROLE_NON_MEMBER = "MEMBER_ROLE_NON_MEMBER",
}